import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSso = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4.562 6.954a3 3 0 0 1 4.49-3.178A5.75 5.75 0 0 1 19.499 6.97a4.002 4.002 0 0 1-.998 7.875h-.689a6 6 0 1 0-11.622 0H5.5a4 4 0 0 1-.938-7.89Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M16 13.344a4.002 4.002 0 0 1-2.75 3.8v4.036a1 1 0 0 1-.293.707l-.624.623a.5.5 0 0 1-.685.02l-1.502-1.334a.5.5 0 0 1-.021-.727l.625-.625-.646-.647a.5.5 0 0 1 0-.707l.646-.646v-.7a4.002 4.002 0 0 1 1.25-7.8 4 4 0 0 1 4 4Zm-4-.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcSso");

export { IcSso };
//# sourceMappingURL=ic-sso.js.map
